export default "__VITE_ASSET__BX9IIv22__"